import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormBase } from '../components/dynamic-form/form-base';

@Injectable()
export class FormGroupControlService {
    constructor() { }

    toFormGroup(feilds: FormBase<any>[], values) {
        let group: any = {};

        feilds.forEach(feild => {
            group[feild.key] = feild.required ? new FormControl(feild.value || '', Validators.required)
                : new FormControl(feild.value || '');
        });
        return new FormGroup(group);
    }
}